/**
 * =========================================================
 * lib/api/config.ts — Konstantet e Rrjetit
 * =========================================================
 * Çfarë bën: Eksporton URL bazë për REST dhe WebSocket.
 *            Lexon variablat e mjedisit VITE_ dhe zbret ne
 *            vlerat fallback per dev lokal nese nuk jane te
 *            konfiguruara.
 * Perdorim:
 *   API_BASE_URL — importohet nga client.ts
 *   WS_BASE_URL  — importohet nga features/messages/pages.tsx
 * =========================================================
 */

const DEFAULT_API_BASE_URL = "https://test.e-shendetesia.com/api/v1";
const DEFAULT_WS_BASE_URL = "wss://test.e-shendetesia.com";

const rawApiUrl = import.meta.env.VITE_API_URL?.trim();
const rawWsUrl = import.meta.env.VITE_WS_URL?.trim();

// Relative Vite proxy URLs krijojnë konfuzion në debug (5173 vs 8000).
// Për dev lokal, i normalizojmë gjithmonë te backend-i real.
export const API_BASE_URL: string =
  !rawApiUrl || rawApiUrl.startsWith("/")
    ? DEFAULT_API_BASE_URL
    : rawApiUrl.replace(/\/+$/, "");

export const WS_BASE_URL: string =
  !rawWsUrl || rawWsUrl.startsWith("/")
    ? DEFAULT_WS_BASE_URL
    : rawWsUrl.replace(/\/+$/, "");

// =========================================================
// Fund i lib/api/config.ts
// =========================================================
